import {call, put, select} from 'typed-redux-saga';
import {SagaIterator} from 'redux-saga';
import {showError, ErrorResponse, takeLatestF, SuccessResponse} from 'favorlogic-utils';

import {handleResponseError} from 'utils/handleResponseError';
import {Ares} from 'types/model/ares/Ares';
import {formValuesF, stopSubmitF} from 'utils/formHelpers';
import {CustomerInvoiceDetails} from 'types/model/common/CustomerInvoiceDetails';
import {Address} from 'types/model/common/Address';
import {StoreState} from 'app/types/StoreState';

import {prefillUpdateCustomerForm, FillUpdateCustomerFormFromAresAction, isAresLoading} from '../actions';
import {UpdateCustomerFormValues} from '../types/UpdateCustomerFormValues';
import Api from '../api';

const errorTitle = 'Načtení zákazníka z ARES';
const formName = 'updateCustomer';

export function getFilledFormValues(ares: Ares, currentValues: UpdateCustomerFormValues): UpdateCustomerFormValues {
    const address: Address = {
        street: ares.street || '',
        city: ares.city || '',
        zip: ares.zip || '',
    };
    const invoiceDetails: CustomerInvoiceDetails = {
        ...currentValues.invoiceDetails,
        dic: ares.dic || '',
    };

    return {
        ...currentValues,
        invoiceDetails,
        address,
        name: ares.companyName || '',
    };
}

function* getCurrentUpdateCustomerFormValues(): SagaIterator<UpdateCustomerFormValues> {
    return yield* select((state: StoreState) => formValuesF(formName)(state).orCrash('Missing form values'));
}

function* handleErrorResponse(response: ErrorResponse): SagaIterator {
    if (!response.isUnauthorized) {
        yield* call(handleResponseError, response, errorTitle);
    }
}

function* handleSuccessResponse({data}: SuccessResponse<Ares | null>): SagaIterator {
    const formValues = yield* call(getCurrentUpdateCustomerFormValues);

    if (data) {
        yield* put(prefillUpdateCustomerForm(getFilledFormValues(data, formValues)));
    } else {
        yield* put(showError(errorTitle, 'Žádné výsledky nebyly nalezeny.'));
        yield* put(stopSubmitF(formName, {
            invoiceDetails: {
                ico: 'IČO nebylo nalezeno v ARES.',
            },
        }));
    }
}

function* execute(action: FillUpdateCustomerFormFromAresAction): SagaIterator {
    yield* put(isAresLoading(true));

    const response = yield* call(Api.getAres, action.payload);

    yield* response.isSuccess ? call(handleSuccessResponse, response) : call(handleErrorResponse, response);
    yield* put(isAresLoading(false));
}

export function* fillUpdateCustomerFormFromAresSaga(): SagaIterator {
    yield takeLatestF('user/FILL_UPDATE_CUSTOMER_FORM_FROM_ARES', execute);
}
